import createDomainSelectors from 'store/createDomainSelectors'
import { initialState } from 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor/reducer'

const { selectSlice } = createDomainSelectors('services/budget-editor', initialState)

export const selectBudgetEditor = selectSlice
// export const selectBudgetEditorBudget = selectField('budget')
// export const selectBudgetEditorDates = selectField('dates')
